/* eslint-disable */
import moment from 'moment';

import { getDateFormat, getTimeFormat } from 'legacy/constants';

export const getDateInDaysHoursMinuit = (dateFrom, dateTo) => {
  const now = dateFrom === null ? moment() : moment(dateFrom);
  const expiration = dateTo === null ? moment() : moment(dateTo);
  // get the difference between the moments
  const diff = expiration.diff(now);
  //express as a duration
  const diffDuration = moment.duration(diff);

  return {
    days: Math.abs(diffDuration.days()),
    hours: Math.abs(diffDuration.hours()),
    minuits: Math.abs(diffDuration.minutes())
  }
}

export const getFormattedDate = (date, me) => {
  const getDate = d => {
    if (!d) {
      return '-';
    }
    const defaultFmt = `${getDateFormat(me)} ${'\n'} ${getTimeFormat(me)}`;
    const displayFormat = defaultFmt;
    // const displaySameDayFormat = `${getTimeFormat(me)}`
    return moment(d).calendar(null, {
      nextDay: displayFormat,
      nextWeek: displayFormat,
      lastWeek: displayFormat,
      sameElse: displayFormat,
      sameDay: displayFormat,
      lastDay: displayFormat,
    });
  };

  return getDate(date).replaceAll('-', '/')
};



// WEBPACK FOOTER //
// ./src/views/components/Common/Table/Utilities/DateUtilities.js